var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('form-wizard', {
    staticClass: "steps-transparent mb-3",
    attrs: {
      "color": "#7367F0",
      "title": null,
      "subtitle": null,
      "finish-button-text": "Submit",
      "back-button-text": "Previous"
    },
    on: {
      "on-complete": _vm.formSubmitted
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Account Details",
      "icon": "feather icon-file-text"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Account Details ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Enter Your Account Details. ")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Username",
      "label-for": "i-username"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-username",
      "placeholder": "johndoe"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "i-email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-email",
      "type": "email",
      "placeholder": "john.doe@email.com"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Password",
      "label-for": "i-password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-password",
      "type": "password",
      "placeholder": "Password"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Confirm Password",
      "label-for": "i-c-password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-c-password",
      "type": "password",
      "placeholder": "Re-type Password"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Personal Info",
      "icon": "feather icon-user"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Personal Info ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Enter Your Personal Info.")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "i-first-name",
      "label": "First Name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-first-name",
      "placeholder": "John"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Last Name",
      "label-for": "i-last-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-last-name",
      "placeholder": "Doe"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Country",
      "label-for": "i-country"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "i-country",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.countryName,
      "selectable": function selectable(option) {
        return !option.value.includes('select_value');
      },
      "label": "text"
    },
    model: {
      value: _vm.selectedContry,
      callback: function callback($$v) {
        _vm.selectedContry = $$v;
      },
      expression: "selectedContry"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Language",
      "label-for": "i-language"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "i-language",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.languageName,
      "selectable": function selectable(option) {
        return !option.value.includes('select_value');
      },
      "label": "text"
    },
    model: {
      value: _vm.selectedLanguage,
      callback: function callback($$v) {
        _vm.selectedLanguage = $$v;
      },
      expression: "selectedLanguage"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Address",
      "icon": "feather icon-map-pin"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Address ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Enter Your Address.")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Address",
      "label-for": "i-address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-address",
      "placeholder": "98 Borough bridge Road, Birmingham"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Landmark",
      "label-for": "i-landmark"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-landmark",
      "placeholder": "Borough bridge"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pincode",
      "label-for": "i-pincode"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-pincode",
      "placeholder": "658921"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "i-city",
      "label": "City"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-city",
      "placeholder": "Birmingham"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Social Links",
      "icon": "feather icon-link"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Social Links ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Enter Your Social Links")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Twitter",
      "label-for": "i-twitter"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-twitter",
      "placeholder": "https://twitter.com/abc"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Facebook",
      "label-for": "i-facebook"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-facebook",
      "placeholder": "https://facebook.com/abc"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Google+",
      "label-for": "i-google-plus"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-google-plus",
      "placeholder": "https://plus.google.com/abc"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "LinkedIn",
      "label-for": "i-linked-in"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "i-linked-in",
      "placeholder": "https://linkedin.com/abc"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }